var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.$style['tab-bar']},[_c('cube-tab-bar',{model:{value:(_vm.valueCrrent),callback:function ($$v) {_vm.valueCrrent=$$v},expression:"valueCrrent"}},_vm._l((_vm.options),function(item){return _c('cube-tab',{key:item[_vm.props.value],attrs:{"label":item[_vm.props.label],"value":item.value}})}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }